import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-generatedMappingFile',
    template: `
  <a (click)="downloadMappingFile($event)" style="color: cornflowerblue;text-decoration: underline;">{{downloadMappingFiles}}</a>`,
    standalone: false
})
export class DownloadMappingFile implements ICellRendererAngularComp {

  params;
  label: string;
  migrationId
  downloadMappingFiles
  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    console.log(this.params);
    this.migrationId=this.params.data.migrationId;
    var mappingFilePath = this.params.data.mappingFilePath
    if (mappingFilePath == null || mappingFilePath == undefined || mappingFilePath == ''){

    }else {
      this.downloadMappingFiles = 'DM_Mappingfile_'+this.migrationId+".xlsx"
    }

    console.log(this.migrationId);
  }

  refresh(params?: any): boolean {
    return true;
  }

  downloadMappingFile($event) {
    console.log("hello")
    if (this.params.downloadMappingFile instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      console.log(params)
      this.params.downloadMappingFile(params);

    }
  }
}
